export default __webpack_public_path__ + "static/media/Anavaram.eb338f61.webp";